import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Divider } from "@mui/joy";

import { IProjectList } from "../../../../../../interfaces";
import { useProject } from "../../../../../../hooks/query";

import { Navigation } from "./Navigation";
import { Basic } from "./Basic";
import { Customer } from "./Customer";
import { Insurance } from "./Insurance";

import "./index.scss";
import { Shield, SquareLibrary, User } from "lucide-react";

export default function Overview() {
    const params = useParams();
    const id = params.id as string;

    const { useListById } = useProject();
    const listProjectByIdSvc = useListById();

    const [projectDetails, setProjectDetails] = useState<IProjectList | null>(null);

    const fetchData = async () => {
        try {
            const response = await listProjectByIdSvc.mutateAsync({ id });
            setProjectDetails(response);
        } catch (e) {
            console.error("Failed to fetch project:", e);
        }
    };

    useEffect(() => {
        if (id) {
            fetchData();
        }
    }, [id]);

    return (
        <Box mt={0.5}>
            <Map details={projectDetails} />
            <Divider sx={{ mt: 2 }} />
            <Box display={"flex"} gap={2} mt={2}>
                <Navigation
                    tabList={[
                        {
                            name: "Basic",
                            icon: <SquareLibrary size={18} />,
                            component: <Basic details={projectDetails} />,
                        },
                        {
                            name: "Customer",
                            icon: <User size={18} />,
                            component: <Customer details={projectDetails} />,
                        },
                        {
                            name: "Insurance",
                            icon: <Shield size={18} />,
                            component: <Insurance details={projectDetails} />,
                        },
                    ]}
                />
            </Box>
        </Box>
    );
}

function Map({ details }: { details: IProjectList | null }) {
    const address = details
        ? `${details.CustomerStreet}, ${details.CustomerCity}, ${details.CustomerZipCode}`
        : "";

    const encodedAddress = encodeURIComponent(address);
    // Use Google Search with output=embed - this is a free way to embed a map view
    // while bypassing OpenStreetMap's strict iframe policies.
    const mapUrl = address
        ? `https://maps.google.com/maps?q=${encodedAddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        : "https://maps.google.com/maps?q=Colorado&t=&z=13&ie=UTF8&iwloc=&output=embed";

    return (
        <iframe
            width="100%"
            height="180"
            src={mapUrl}
            style={{ border: "1px solid", borderColor: "var(--joy-palette-divider)", borderRadius: "10px" }}
            title="Project Location Map"
        ></iframe>
    );
}
